export const footerMoreLinks = {
  'ma-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://ma.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://ma.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://ma.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://ma.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://ma.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://ma.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'ma-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://ma.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ma.wingie.com/en/faq/',
          title: 'FAQ',
        },
        {
          href: 'https://ma.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://ma.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ma.wingie.com/en/terms-and-conditions/',
          title: 'Terms and conditions',
        },
        {
          href: 'https://ma.wingie.com/en/awards/',
          title: 'Our awards',
        },
      ],
    },
  ],
  'ma-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://ma.wingie.com/fr/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ma.wingie.com/fr/faq/',
          title: 'Questions fréquentes',
        },
        {
          href: 'https://ma.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://ma.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://ma.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et conditions',
        },
        {
          href: 'https://ma.wingie.com/fr/awards/',
          title: 'Nos récompenses',
        },
      ],
    },
  ],
  'ma-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://ma.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://ma.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },
        {
          href: 'https://ma.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://ma.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://ma.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://ma.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'ma-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://ma.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://ma.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas frecuentes',
        },
        {
          href: 'https://ma.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://ma.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://ma.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones',
        },
        {
          href: 'https://ma.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'ma-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://ma.wingie.com/it/contact/',
          title: 'Contatto',
        },
        {
          href: 'https://ma.wingie.com/it/faq/',
          title: 'Domande frequenti',
        },
        {
          href: 'https://ma.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://ma.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ma.wingie.com/it/terms-and-conditions/',
          title: 'Termini e condizioni',
        },
        {
          href: 'https://ma.wingie.com/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'ma-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://ma.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://ma.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://ma.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://ma.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://ma.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://ma.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'ma-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://ma.wingie.com/pt/contact/',
          title: 'Contato',
        },
        {
          href: 'https://ma.wingie.com/pt/faq/',
          title: 'Perguntas frequentes',
        },
        {
          href: 'https://ma.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://ma.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://ma.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e condições',
        },
        {
          href: 'https://ma.wingie.com/pt/awards/',
          title: 'Nossos prêmios',
        },
      ],
    },
  ],
  'ma-ro': [
    {
      title: 'Mai multe',
      items: [
        {
          href: 'https://ma.wingie.com/ro/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ma.wingie.com/ro/faq/',
          title: 'Întrebări frecvente',
        },
        {
          href: 'https://ma.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://ma.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://ma.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și condiții',
        },
        {
          href: 'https://ma.wingie.com/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'ma-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://ma.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        {
          href: 'https://ma.wingie.com/pl/faq/',
          title: 'Często zadawane pytania',
        },
        {
          href: 'https://ma.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://ma.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://ma.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://ma.wingie.com/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'ma-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://ma.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        {
          href: 'https://ma.wingie.com/lt/faq/',
          title: 'Dažnai užduodami klausimai',
        },
        {
          href: 'https://ma.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://ma.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://ma.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir sąlygos',
        },
        {
          href: 'https://ma.wingie.com/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'ma-uz': [
    {
      title: 'Boshqa',
      items: [
        {
          href: 'https://ma.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        {
          href: 'https://ma.wingie.com/uz/faq/',
          title: "Ko'p beriladigan savollar",
        },
        {
          href: 'https://ma.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://ma.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://ma.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va qoidalar',
        },
        {
          href: 'https://ma.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'ma-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://ma.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        {
          href: 'https://ma.wingie.com/sr/faq/',
          title: 'Честа питања',
        },
        {
          href: 'https://ma.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://ma.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://ma.wingie.com/sr/terms-and-conditions/',
          title: 'Услови коришћења',
        },
        {
          href: 'https://ma.wingie.com/sr/awards/',
          title: 'Наше награде',
        },
      ],
    },
  ],
  'ma-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://ma.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        {
          href: 'https://ma.wingie.com/ky/faq/',
          title: 'Көп берилүүчү суроолор',
        },
        {
          href: 'https://ma.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://ma.wingie.com/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://ma.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана эрежелер',
        },
        {
          href: 'https://ma.wingie.com/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'ma-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://ma.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        {
          href: 'https://ma.wingie.com/tg/faq/',
          title: 'Саволҳои зуд-зуд пурсида мешаванда',
        },
        {
          href: 'https://ma.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://ma.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://ma.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва қоидаҳо',
        },
        {
          href: 'https://ma.wingie.com/tg/awards/',
          title: 'Мукофотҳои мо',
        },
      ],
    },
  ],
  'ma-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://ma.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        {
          href: 'https://ma.wingie.com/kk/faq/',
          title: 'Жиі қойылатын сұрақтар',
        },
        {
          href: 'https://ma.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://ma.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://ma.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://ma.wingie.com/kk/awards/',
          title: 'Біздің марапаттар',
        },
      ],
    },
  ],
  'ma-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://ma.wingie.com/nl/contact/',
          title: 'Contact',
        },
        {
          href: 'https://ma.wingie.com/nl/faq/',
          title: 'Veelgestelde vragen',
        },
        {
          href: 'https://ma.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://ma.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://ma.wingie.com/nl/terms-and-conditions/',
          title: 'Algemene voorwaarden',
        },
        {
          href: 'https://ma.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'ma-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://ma.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://ma.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://ma.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://ma.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://ma.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://ma.wingie.com/ja/awards/' },
      ],
    },
  ],
  'ma-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://ma.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://ma.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://ma.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://ma.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://ma.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://ma.wingie.com/zh/awards/' },
      ],
    },
  ],
  'ma-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://ma.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://ma.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://ma.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://ma.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://ma.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://ma.wingie.com/ko/awards/' },
      ],
    },
  ],
  'ma-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://ma.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://ma.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://ma.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://ma.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://ma.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://ma.wingie.com/hi/awards/' },
      ],
    },
  ],
  'ma-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://ma.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://ma.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://ma.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://ma.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://ma.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://ma.wingie.com/ta/awards/' },
      ],
    },
  ],
  'ma-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://ma.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://ma.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://ma.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://ma.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://ma.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://ma.wingie.com/th/awards/' },
      ],
    },
  ],
  'ma-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://ma.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://ma.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://ma.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://ma.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://ma.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://ma.wingie.com/ur/awards/' },
      ],
    },
  ],
  'ma-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://ma.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://ma.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://ma.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://ma.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://ma.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://ma.wingie.com/ka/awards/' },
      ],
    },
  ],
}
